import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompIconPickerWrapperCore } from '../core/icon-picker/wrapper'
import { CompIconPicker } from './CompIconPicker'

function CompIconPickerWrapper() {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useCompBackgroundColor()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // form
  const formContext = useCompFormContext()

  return (
    <CompIconPickerWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompIconPicker {...props} />}
    </CompIconPickerWrapperCore>
  )
}

export default CompIconPickerWrapper
